

<div class="container-fluid">
    <div class="row m-0 p-1">
        <div class="bg-white rounded shadow col-lg-12 m-0 p-1">
            <form [formGroup]="form">                                                                                                                                                                                                                 
        
            <div class="col-lg row m-0 p-0">
            <div class="col-lg m-0 p-1">
                <div class="title-header"><h5 class="m-0 p-0">REPORTS</h5></div>
                
            </div>
            <div class="col-lg p-1 my-auto">         
                <div class="type-2 my-auto" data-toggle="collapse" data-target="#collapseOne">
                    <div class="">
                        <a class="btn btn-1">
                        <span class="txt">filter</span>
                        <span class="round" ><i class="fa fa-filter fa-md"></i></span>
                        </a>
                    </div> 
                </div> 
            </div>           
            </div>

            <div class="row m-0 p-2 d-flex" *ngIf="!is_Admin_User">
                <p class="m-0 p-0 img-grid-title">{{regionName}}&nbsp;&nbsp;&#187;&nbsp;&nbsp;</p>
                <p class="m-0 p-0 img-grid-title">{{showroomName}}</p>
            </div>
            <div id="collapseOne" class="collapse p-2 my-auto" aria-labelledby="headingOne">
                <fieldset >
                    <div class="row col-lg-12 p-0">
                        <div class="col-sm" *ngIf="is_Admin_User">     
                            <label class="header_text">Region</label>
                            <select  #region class="custom-select round" formControlName="region_id" (change)="onRegionChange(region.value)">
                                    <option value="">All Regions</option>
                                    <option *ngFor="let data of RegionDataLists" [value]="data.id">{{data.name}}</option>
                            </select>
                        </div>
                        <div class="col-sm" *ngIf="is_Admin_User">
                            <label class="header_text">Showroom</label>
                                <ng-multiselect-dropdown class="select-cstyle"
                                    [placeholder]="'All showroom'"
                                    [settings]="dropdownSettings"
                                    [data]="FilterShowroomLists"
                                    formControlName="showroom_id"
                                    (onSelect)="onShowroomItemSelect($event)"
                                    (onDeSelect)="onShowroomItemDeSelect($event)"
                                    (onSelectAll)="onShowroomSelectAll()"
                                    (onDeSelectAll)="onShowroomDeSelectAll()">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="col-sm">
                            <label class="header_text">Assets</label>
                            <ng-multiselect-dropdown class="select-cstyle" 
                                [placeholder]="'All Assets'"
                                [settings]="dropdownSettings" formControlName="asset_type_id"
                                [data]="AssetsDataLists"
                                (onSelect)="onItemSelect($event)"
                                (onDeSelect)="onItemDeSelect($event)"
                                (onSelectAll)="onSelectAll()"
                                (onDeSelectAll)="onDeSelectAll()">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="col-sm">
    
                            <label class="header_text">Creative</label>
    
                            <ng-multiselect-dropdown class="select-cstyle"
                                [placeholder]="'All Creatives'"
                                [settings]="dropdownSettings"
                                [data]="CreativeDataLists"
                                formControlName="creative_id"
                                (onSelect)="onCreativeItemSelect($event)"
                                (onDeSelect)="onCreativeItemDeSelect($event)"
                                (onSelectAll)="onCreativeSelectAll()"
                                (onDeSelectAll)="onCreativeDeSelectAll()">
                            </ng-multiselect-dropdown>
    
                    
                        </div>
                        <div class="col-sm">
                            <label class="header_text">Vendor</label>
    
                            <ng-multiselect-dropdown class="select-cstyle"
                                [placeholder]="'All Vendors'"
                                [settings]="dropdownSettings"
                                [data]="VendorDataLists"
                                formControlName="vendor_id"
                                (onSelect)="onVendorItemSelect($event)"
                                (onDeSelect)="onVendorItemDeSelect($event)"
                                (onSelectAll)="onVendorSelectAll()"
                                (onDeSelectAll)="onVendorDeSelectAll()">
                            </ng-multiselect-dropdown>
                        </div>   
    
                        
                    </div>
                    <div class="row col-lg-12 p-0">
                        <div class="col-sm">
                            <label class="header_text">Installation Date</label>
                            <div class="form-group mb-0">
                                <mat-form-field appearance="fill">
                                    <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Start date" matInput  formControlName="installation_date_start"  (dateChange)="installChange($event)">
                                    <input matEndDate placeholder="End date" matInput  formControlName="installation_date_end"  (dateChange)="installChangeEnd($event)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm">
                                <label class="header_text">Expiry Date</label>
                                <div class="form-group mb-0">
                                    <mat-form-field appearance="fill">
                                        <mat-date-range-input [rangePicker]="pickerExpiry">
                                        <input matStartDate placeholder="Start date" matInput  formControlName="expiry_date_start"  (dateChange)="expiryChange($event)">
                                        <input matEndDate placeholder="End date" matInput  formControlName="expiry_date_end"  (dateChange)="expiryChangeEnd($event)">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="pickerExpiry"></mat-datepicker-toggle>
                                        <mat-date-range-picker #pickerExpiry></mat-date-range-picker>
                                    </mat-form-field>
                            </div>
    
                        </div>
                        <div class="col-sm">
                            <label class="header_text">Search</label>
                            <div class="custom-search">
                                <input type="text" formControlName="search" class="custom-search-input" placeholder="Search for" [(ngModel)]="term">
                            </div>
                        </div>
                        <div class="col-sm my-auto">    
                            <button class="btn btn-reset align-items-center" (click)="clearFilters()"><u>Reset filter</u></button>
                        </div> 
                    </div>
              </fieldset>
            </div>
    
              <div class="row col-lg-12 m-0 p-0">
                <div class="col-md-6 grt-include p-0">
                    <div class="row m-0 p-2 my-auto">
                        <input type="checkbox" id="todo" [(ngModel)]="isChecked" (change)="checkValue()" formControlName="include" name="todo" value="todo" class="">
                        <label class="m-0 pl-1" for="todo" data-content="Include Discontinued">Include Discontinued</label>
                    </div>
                   
                </div>
                <div class="col-md-6 d-flex justify-content-end m-0 p-0">
                    <div class="radio">
                    <input id="instore" name="radio" type="radio" checked (change)="changeInstore($event)">
                    <label  for="instore" class="radio-label">Instore</label>
                    </div>
                    <div class="radio">
                        <input id="hoarding" name="radio" type="radio" (change)="changeHoarding($event)">
                        <label  for="hoarding" class="radio-label">Hoarding</label>
                    </div>
                </div>
              </div>
            </form>

            <div class="box-table table-responsive p-2" id="pdfTable" #pdfTable>
                <table class="box-table table table-borderless m-0 p-0" id="excel-table" cellspacing="0" width="100%"  
                       matSort (matSortChange)="sortData($event)" matSortActive="" matSortDirection="asc" matSortDisableClear>
                    <thead class="">
                        <tr class="justify-content-center ">
                            <th *ngIf="isChecked" class="text-center"><p class="m-0">Active / Inactive</p></th>
                            <th class="" mat-sort-header = "regionName"><p class="m-0">Region</p></th>
                            <th mat-sort-header = "showroomName"><p class="m-0">Showroom</p></th>
                            <th mat-sort-header = "floorName" *ngIf="selModule==1"><p class="m-0">Floor</p></th>
                            <th *ngIf="selModule==1"><p class="m-0">Location</p></th>
                            <th class="w-area" *ngIf="selModule==3"><p class="text-center m-0">Area</p></th>
                            <th class="w-address" *ngIf="selModule==3"><p class="text-center m-0">Address</p></th>
                            <th mat-sort-header = "assetTypeName"><p class="m-0">Type</p></th>
                            <th mat-sort-header = "creativeName"><p class="m-0">Creative</p></th>
                            <th class="w-remarks text-center"><p class="m-0">Particulars</p></th>
                            <th><p class="text-center m-0">Size</p></th>
                            <th *ngIf="selModule==3"><p class="text-center m-0">Square Feet</p></th>
                            <th *ngIf="selModule==2 || selModule==3"><p class="text-center m-0">Cost</p></th>
                            <th><p class="text-center m-0">Name</p></th>
                            <th mat-sort-header = "vendorName"><p class="m-0">Vendor</p></th>
                            <th><p class="text-center m-0">Installation Date</p></th>
                            <th><p class="text-center m-0">Expiry Date</p></th>
                            <th><p class="text-center m-0">Modified Date</p></th>
                            <th><p class="text-center m-0">Created Date</p></th>
                            <th mat-sort-header = "expiryDays"><p class="text-center m-0">Expiry Days</p></th>
                            <th><p class="text-center  m-0">Image</p></th> 
                        
                        </tr>
                    </thead>
    
                    <tbody class="instore_table" *ngIf="selModule==1">  <!--Instore-->
                        <tr class="" *ngFor="let data of filterInstoreLists| filter:term | slice: (page-1) * pageSize : page * pageSize;let i=index" >
                            <td class="text-center"  *ngIf="isChecked">
                                <a class="" *ngIf="data.is_discontinued==1">    
                                    <button class="btn btn-success btn-w" (click)="restoreInstore(data.id)">Restore</button>
                                </a> 
                                <div class="d-flex m-0 p-0 justify-content-center"  *ngIf="data.is_discontinued==0">
                                    <span class="dot-active"></span><p class="m-0">Active</p>
                                </div> 
                            </td>

                            <td><p class="m-0">{{data.regionName}}</p></td>
                            <td><p class="m-0">{{data.showroomName}}</p></td>
                            <td><p class="m-0 p-0">{{data.floorName}}</p></td>
                            <td><p class="m-0">{{data.locationName}}</p></td>
                            <td><p class="m-0">{{data.assetTypeName}}</p></td>
                            <td><p class="m-0">{{data.creativeName}}</p></td>
                            <td><p class="text-center m-0">{{data.particulars}}</p>
                            <td><p class="text-center m-0">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                            <td><p class="m-0 text-center">{{data.name}}</p></td>
                            <td><p class="m-0">{{data.vendorName}}</p></td> 
                          
                            <td ><p class="text-center m-0 p-0">{{data.install_date| date: 'dd/MM/yyyy'}}</p></td>
                            <td><p class="text-center m-0">{{data.expiry_date| date: 'dd/MM/yyyy'}}</p></td> 
                            <td ><p class="text-center m-0 p-0">{{data.lastChanged| date: 'dd/MM/yyyy'}}</p></td>
                            <td><p class="text-center m-0">{{data.firstChanged| date: 'dd/MM/yyyy'}}</p></td>                                                                      
                            <td><p class="text-center m-0 font-weight-bold"  [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p></td>
                            <td class="text-center pointer">
                                <p (click)="open(mymodal,data)"><i class="fa fa-eye fa-sm" aria-hidden="true"></i></p>
                            </td>
                            
                        </tr>
                    </tbody>             

                    <!-- <tbody class="" *ngIf="selModule==2"> 
                        <tr class="" *ngFor="let data of filterInstoreLists| filter:term | slice: (page-1) * pageSize : page * pageSize;let i=index" >
                            <td class="text-center"><p class="m-0">{{data.regionName}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.showroomName}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.assetTypeName}}</p></td>
                            <td class="text-center"> <p class="m-0">{{data.creativeName}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.particulars}}</p>
                            <td class="text-center"><p class="m-0">W {{data.size_w}}"  H {{data.size_h}}"</p>
                            <td class="text-center" ><p class="m-0 p-0">&#8377;&nbsp;{{data.cost}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.festival_name}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.vendorName}}</p></td> 
                            <td class="text-center"><p class="m-0"></p></td>
                            <td class="text-center" ><p class="m-0 p-0">{{data.start_date}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.end_date}}</p></td>                                               
                            <td class="text-center"><p class="m-0">{{data.expiryDays}}</p></td>
                        </tr>
                    </tbody>-->
                    <!--Hoarding-->
                    <tbody class="hoarding_table" *ngIf="selModule==3">  
                        <tr class="" *ngFor="let data of filterInstoreLists| filter:term | slice: (page-1) * pageSize : page * pageSize;let i=index" >

                            <td class="text-center" *ngIf="isChecked">
                                <a class="mr-2" *ngIf="data.is_discontinued==1">    
                                    <button class="btn btn-success btn-w" (click)="restoreHoarding(data.id)">Restore</button>
                                </a> 
                                <div class="d-flex m-0 p-0 justify-content-center"  *ngIf="data.is_discontinued==0">
                                    <span class="dot-active"></span><p class="m-0">Active</p>
                                </div> 
                            </td>


                            <td class=""><p class="m-0">{{data.regionName}}</p></td>
                            <td class=""><p class="m-0">{{data.showroomName}}</p></td>
                            <td class="text-center "><p class="m-0">{{data.area}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.address}}</p></td>
                            <td class=""><p class="m-0">{{data.assetTypeName}}</p></td>
                            <td class=""> <p class="m-0">{{data.creativeName}}</p></td>
                            <td class=""><p class="text-center m-0">{{data.particulars}}</p>
                            <td class="text-center"><p class="m-0">W {{splitNumber(data.size_w)}} x  H {{splitNumber(data.size_h)}}</p>
                            <td class="text-center" ><p class="m-0 p-0">{{splitNumber(data.size_w*data.size_h)}}</p></td>
                            <td class="text-center" ><p class="m-0 p-0">{{data.cost| currency:'INR'}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.name}}</p></td>
                            <td class=""><p class="m-0">{{data.vendorName}}</p></td>
                           
                            <td class="text-center" ><p class="m-0 p-0">{{data.install_date| date: 'dd/MM/yyyy'}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.expiry_date| date: 'dd/MM/yyyy'}}</p></td> 
                            <td class="text-center" ><p class="m-0 p-0">{{data.lastChanged| date: 'dd/MM/yyyy'}}</p></td>
                            <td class="text-center"><p class="m-0">{{data.firstChanged| date: 'dd/MM/yyyy'}}</p></td>         
                            <td class=""><p class="text-center m-0 font-weight-bold"  [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p></td>                                              
                            <td class="text-center pointer">                 
                                <p (click)="open(mymodal,data)"><i class="fa fa-eye fa-sm" aria-hidden="true"></i></p>      
                            </td>
                        </tr>
                    </tbody>             

                </table>

                <div class="text-center p-5" *ngIf="filterInstoreLists && filterInstoreLists.length === 0" >
                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                    </svg>
                    <p class="m-0 no-record"> No Record Found </p>
                </div>
            </div>             

            <div *ngIf="filterInstoreLists && filterInstoreLists.length > 10" class="m-3 sl-pagination text-center justify-content-center d-flex">
                <ngb-pagination  [(page)]="page"  [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" 
                [collectionSize]="filterInstoreLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
            </div>
            <div class="demopadding">
                <!-- <div class='icon social print m-2' ngbTooltip="Print" ><i class='fa fa-print'></i></div> -->
                <div class='icon social pdf m-2' ngbTooltip="Export to pdf" (click)="downloadAsPDF()"><i class='fa fa-file-pdf-o'></i></div>
                <div class='icon social xl m-2'  ngbTooltip="Export to .xls" (click)="exportexcel()"><i class='fa fa-file-excel-o'></i></div>
            </div>  
        </div>
    </div>
</div>
<ng-template #mymodal let-modal>
<div class="modal-header p-2 m-0">
    <h4 class="modal-title m-0 p-0" id="modal-basic-title">{{InstoreHoardingData.name}}</h4>
    <i class="fa fa-lg fa-times-circle text-right mt-2 pointer" (click)="modal.dismiss('Cross click')"></i>
</div>

<div class="modal-body preview-data text-center">
    <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{InstoreHoardingData.image}}" onerror="this.src='/assets/grt.svg'" alt="" class="p-0"/>
</div>
</ng-template>